"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _orderListApi = _interopRequireWildcard(require("@/api/orderListApi.js"));
var orderListApi = _orderListApi;
var _throttle = _interopRequireDefault(require("@/utils/throttle"));
var _static = require("../static");
var _transformState = _interopRequireDefault(require("@/utils/transformState.js"));
var _importTransport = _interopRequireDefault(require("../lists/importTransport.vue"));
var _orderDetail = _interopRequireDefault(require("../lists/orderDetail2.vue"));
var _orderSend = _interopRequireDefault(require("../lists/orderSend2.vue"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _orderStatusPopup = _interopRequireDefault(require("./orderStatusPopup.vue"));
var _sendKami = _interopRequireDefault(require("./sendKami.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    ImportTransport: _importTransport.default,
    OrderDetail: _orderDetail.default,
    OrderSend: _orderSend.default,
    OrderStatusPopup: _orderStatusPopup.default,
    SendKami: _sendKami.default
  },
  data: function data() {
    return {
      isExporting: false,
      // 是否正在导出
      exportSuccess: false,
      // 导出是否成功
      exportProgress: 0,
      // 导出进度
      customColors: [{
        color: '#f56c6c',
        percentage: 20
      }, {
        color: '#e6a23c',
        percentage: 40
      }, {
        color: '#5cb87a',
        percentage: 60
      }, {
        color: '#1989fa',
        percentage: 80
      }, {
        color: '#67c23a',
        percentage: 100
      }],
      orderStateOption: _static.orderStateOption,
      goodsTypeOption: _static.goodsTypeOption,
      orderTypeOption: _static.orderTypeOption,
      pintuanOrderStates: _static.pintuanOrderStates,
      JavaInfo: JSON.parse(_jsCookie.default.get('JavaInfo')),
      homeType: false,
      constants: this.$constants,
      listPram: {
        page: 1,
        limit: this.$constants.page.limit[0]
      },
      listData: {
        list: [],
        total: 0
      },
      listLoading: false,
      orderTypeOptions: [],
      deliveryStatusList: [],
      TYPE_COLOR_MAP: {
        1: 'info',
        2: 'success',
        3: 'success',
        4: '',
        5: 'info',
        6: 'warning',
        7: 'danger',
        8: '',
        9: ''
      },
      customerId: null
    };
  },
  created: function created() {
    var _this$JavaInfo, _this$JavaInfo2;
    this.getAllOrderType();
    this.customerId = (_this$JavaInfo = this.JavaInfo) === null || _this$JavaInfo === void 0 ? void 0 : _this$JavaInfo.customerId;
    this.homeType = ((_this$JavaInfo2 = this.JavaInfo) === null || _this$JavaInfo2 === void 0 ? void 0 : _this$JavaInfo2.homeType) === 2;
  },
  mounted: function mounted() {
    if (this.$route.query.status) {
      this.listPram.status = this.$route.query.status;
      this.handerSearch();
    } else {
      this.handlerGetListData(this.listPram);
    }
  },
  methods: {
    throttle: _throttle.default,
    transformState: _transformState.default,
    getAllOrderType: function getAllOrderType() {
      var _this = this;
      this.orderTypeOptions = [];
      orderListApi.getOrderTypes().then(function (res) {
        _this.orderTypeOptions = res || [];
      });
    },
    handerSearch: function handerSearch() {
      var doRefresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      // 是否刷新
      if (doRefresh == 1) {
        this.listPram = {
          page: 1,
          limit: this.$constants.page.limit[0]
        };
      }
      ;
      this.listPram.page = 1;
      this.handlerGetListData(this.listPram);
    },
    handlerGetListData: function handlerGetListData() {
      var _this$JavaInfo3,
        _this2 = this;
      var pram = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!this.checkPass()) return;
      this.listLoading = true;
      var requestParams = _objectSpread(_objectSpread({}, pram), {}, {
        supplierId: (_this$JavaInfo3 = this.JavaInfo) === null || _this$JavaInfo3 === void 0 ? void 0 : _this$JavaInfo3.supplierId
      });
      console.log('完整请求参数:', requestParams);
      console.log('物流状态参数:', requestParams.deliveryStatusName);
      orderListApi.supplierListArticle(requestParams).then(function (data) {
        _this2.listData = data.page;
        console.log(_this2.listData);
        // 提取物流状态列表
        if (data.deliveryStatusList) {
          _this2.deliveryStatusList = data.deliveryStatusList;
        }
        _this2.listLoading = false;
      }).catch(function (err) {
        console.error('API请求失败:', err);
        _this2.listLoading = false;
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listPram.limit = val;
      this.handlerGetListData(this.listPram);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listPram.page = val;
      this.handlerGetListData(this.listPram);
    },
    // 导入订单
    doImport: function doImport() {
      if (!this.checkPass()) return;
      this.$refs['ImportTransportRef'].openInit();
    },
    // 查看订单详情
    openOrderDetail: function openOrderDetail(orderNo) {
      this.$refs['OrderDetailRef'].openDetail(orderNo);
    },
    stateChange: function stateChange() {
      this.$refs['ImportTransportRef'].openInit();
    },
    // 导出
    exportList: function exportList() {
      if (!this.checkPass()) return;
      orderListApi.exportCustomerOrderList2(this.listPram).then(function (res) {
        window.open(res.fileName);
      });
    },
    // 订单导出（可以根据筛选条件）
    exportList2: function exportList2() {
      var _this3 = this;
      if (!this.checkPass()) return;
      this.isExporting = true; // 显示导出中提示
      this.exportProgress = 0; // 重置导出进度

      // 模拟导出进度，更慢的进度
      var intervalId = setInterval(function () {
        // 根据当前进度设置不同的增长速度
        var increment = 0;
        if (_this3.exportProgress < 30) {
          increment = 5; // 开始阶段快一点
        } else if (_this3.exportProgress < 60) {
          increment = 3; // 中间阶段慢一点
        } else {
          increment = 2; // 后期非常慢
        }
        _this3.exportProgress += increment;
        if (_this3.exportProgress >= 85) {
          clearInterval(intervalId); // 停止进度模拟
          // 保持在85%，等待实际完成后设为100%
          _this3.exportProgress = 85;
        }
      }, 800); // 每800毫秒增加一次进度

      // 发起导出请求
      orderListApi.exportOrderList2(this.listPram).then(function (res) {
        clearInterval(intervalId); // 停止进度模拟
        _this3.exportProgress = 100; // 设置进度为100%

        setTimeout(function () {
          _this3.isExporting = false; // 延迟关闭对话框
          if (res.fileName) {
            window.open(res.fileName);
          }
        }, 1500);
      }).catch(function (error) {
        clearInterval(intervalId); // 停止进度模拟
        _this3.isExporting = false; // 隐藏导出中提示
        _this3.$message.error('导出请求失败: ' + error.message);
      });
    },
    exportOrderSendList: function exportOrderSendList() {
      var _this4 = this;
      if (!this.checkPass()) return;
      this.isExporting = true; // 显示导出中提示
      this.exportProgress = 0; // 重置导出进度

      // 模拟导出进度，更慢的进度
      var intervalId = setInterval(function () {
        // 根据当前进度设置不同的增长速度
        var increment = 0;
        if (_this4.exportProgress < 30) {
          increment = 5; // 开始阶段快一点
        } else if (_this4.exportProgress < 60) {
          increment = 3; // 中间阶段慢一点
        } else {
          increment = 2; // 后期非常慢
        }
        _this4.exportProgress += increment;
        if (_this4.exportProgress >= 85) {
          clearInterval(intervalId); // 停止进度模拟
          // 保持在85%，等待实际完成后设为100%
          _this4.exportProgress = 85;
        }
      }, 800); // 每800毫秒增加一次进度

      // 发起导出请求
      orderListApi.exportOrderSendList2(this.listPram).then(function (res) {
        clearInterval(intervalId); // 停止进度模拟
        _this4.exportProgress = 100; // 设置进度为100%

        setTimeout(function () {
          _this4.isExporting = false; // 延迟关闭对话框
          if (res.fileName) {
            window.open(res.fileName);
          }
        }, 1500);
      }).catch(function (error) {
        clearInterval(intervalId); // 停止进度模拟
        _this4.isExporting = false; // 隐藏导出中提示
        _this4.$message.error('导出请求失败: ' + error.message);
      });
    },
    sendOrder: function sendOrder(orderNo) {
      this.$refs['OrderSendRef'].openInit({
        orderNo: orderNo
      });
    },
    checkPass: function checkPass() {
      var _this$JavaInfo4;
      var pass = Boolean((_this$JavaInfo4 = this.JavaInfo) === null || _this$JavaInfo4 === void 0 ? void 0 : _this$JavaInfo4.supplierId);
      if (!pass) {
        this.$message.error('supplierId为空');
        return;
      }
      ;
      return pass;
    },
    handelStatusPopup: function handelStatusPopup(row) {
      this.$refs['orderStatusPopupRefs'].handlePopupOpen(row);
    },
    bindOrderKami: function bindOrderKami(orderNo) {
      var _this5 = this;
      orderListApi.updataKami({
        orderNo: orderNo
      }).then(function (res) {
        _this5.$message.success('操作成功');
        _this5.handerSearch(0);
      });
    },
    sendOrderKami: function sendOrderKami(row) {
      this.$refs['SendKamiRef'].openInit(row);
    }
  }
};